import { AbstractControl, ValidatorFn } from '@angular/forms';

export function isObject(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isObjectSet = typeof control.value === 'object' && control.value;
    return isObjectSet ? null : { isObject: { value: control.value } };
  };
}
